module.exports = __webpack_public_path__ + "media/images/mobile-nav-trigger-260a88102f44eef2b22b10063204a71f.gif";